import React from "react";

const RetakeQuiz = ({ onRetake }) => {
	const handleRetake = () => {
		onRetake();
	};
	return (
		<div className="flex flex-col items-center w-full h-full mt-16 min-w-80 max-w-80 sm:min-w-96 sm:max-w-96 bg-white p-6 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] ">
			<h1 className="text-2xl text-gray-600 font-bold text-center mb-8">
				Vous avez déjà terminé ce quiz
			</h1>
			<p className="text-gray-600 my-3">
				Si vous souhaitez rejouer et refaire le quiz, cliquez sur le bouton
				ci-dessous.
			</p>
			<button
				onClick={handleRetake}
				className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
			>
				Refaire le quiz
			</button>
		</div>
	);
};

export default RetakeQuiz;
